import type { SoTienGuiNganHangItem, SoTienGuiNganHangRequest } from '@/types/schemas/so-tien-gui-ngan-hang.type';
import { SearchFormValues } from '../schema';
import { NganHang } from '@/types/schemas';

export const sanitizeSearchParams = (params?: SearchFormValues | null): SoTienGuiNganHangRequest => {
  if (!params) return {} as SoTienGuiNganHangRequest;
  const { tk_code, tk_name, ...rest } = params;
  return rest as SoTienGuiNganHangRequest;
};

export const formatDateRangeValue = (value?: string) => {
  if (!value) return '';
  if (/^\d{8}$/.test(value)) {
    const year = value.slice(0, 4);
    const month = value.slice(4, 6);
    const day = value.slice(6, 8);
    return `${day}/${month}/${year}`;
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-');
    return `${day}/${month}/${year}`;
  }
  return value;
};

export const getNganHangName = (nganHangs: NganHang[], uuid?: string | null) => {
  if (!uuid) return '';
  const nganHang = nganHangs.find(nh => nh.uuid === uuid);
  return nganHang ? `${nganHang.ma_ngan_hang} - ${nganHang.ten_ngan_hang}` : uuid;
};

export const buildSubtitle = (params: SearchFormValues, nganHangs: NganHang[]) => {
  const accountLabel =
    params?.tk_code || params?.tk_name ? [params.tk_code, params.tk_name].filter(Boolean).join(' - ') : '';
  const bankName = getNganHangName(nganHangs, params?.tknh || '');
  const from = formatDateRangeValue(params?.ngay_ct1);
  const to = formatDateRangeValue(params?.ngay_ct2);
  if (accountLabel || bankName || (from && to)) {
    return `Tài khoản: ${accountLabel || '...'}, Ngân hàng: ${bankName || '...'}, từ ngày ${
      from || '...'
    } đến ngày ${to || '...'}`;
  }
  return '';
};

export function formatDateToYYYYMMDD(dateString: string): string {
  if (!dateString) return '';
  return dateString;
}

export const getRowClassName = (params: { row?: Pick<SoTienGuiNganHangItem, 'stt'> }) => {
  if (params.row?.stt === 1 || params.row?.stt === 2 || params.row?.stt === 3) {
    return 'font-bold';
  }
  return '';
};
